import { datajsAll } from '../shared/utils';
import Swiper, { Autoplay, Pagination } from 'swiper';

export default class HeroSlider {
	static init() {
		const sliders = datajsAll('hero-slider');

		sliders.forEach((slider) => {
			this.sliderConfig(slider);
		});
	}

	static sliderConfig(slider) {
		// eslint-disable-next-line no-new
		const sliderInstance = new Swiper(slider, {
			modules: [Autoplay, Pagination],
			loop: true,
			slidesPerView: 1,
			speed: 500,

			autoplay: {
				delay: 8000,
			},

			breakpoints: {
				1024: {
					speed: 1000,
					noSwiping: true,
					noSwipingSelector: '.m-pageHeaderSlideImage',
				},
				1440: {
					speed: 1000,
					noSwiping: true,
					noSwipingSelector: '.m-pageHeaderSlideImage',
				},
			},

			// If we need pagination
			pagination: {
				el: '.m-sliderPagination',
				bulletClass: 'm-sliderPagination__item',
				bulletActiveClass: 'is-active',
				clickable: true,
			},
		});

		// Play/Pause on hover
		slider.addEventListener(
			'mouseover',
			function () {
				sliderInstance.autoplay.stop();
			},
			false
		);
		slider.addEventListener(
			'mouseleave',
			function () {
				sliderInstance.autoplay.start();
			},
			false
		);
	}
}
